import { useTranslation } from "react-i18next";
import { Grid, Grow, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField } from "@mui/material";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";
import AddButton from "../../components/AddButton/AddButton";
import SearchBar from "../../components/SearchBar/SearchBar";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteSparePartNote, getSparePartNoteList, saveSparePartNote, updateSparePartNote } from "../../store/actions/SparePartActions";
import SparePartNoteActionButtons from "../../components/Button/SparePartNoteActionButtons";

export default function SparePartNoteDefinitions(props) {
    const { t } = useTranslation("translation");

    const dispatch = useDispatch();
    const [pageLoaded, setPageLoaded] = useState(false);
    const [isButtonDisable, setIsButtonDisable] = useState(true);
    let [rows, setRows] = useState([]);
    const [tempNote, setTempNote] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);

    const HandleChangePage = (_event, newPage) => {
        setCurrentPage(newPage);
        fetchSparePartNote(newPage, rowsPerPage);
        setEditable(false);
        setIsButtonDisable(false);
    }

    const HandleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setCurrentPage(0);
        fetchSparePartNote(currentPage, event.target.value);
    };

    // Validation
    const [error, setError] = useState({
        noteText: t("EmptyCheck")
    });

    useEffect(() => {
        const newNote = tempNote !== "" ? "" : t("EmptyCheck");
        setError({
            noteText: newNote
        });
    }, [tempNote]);

    useEffect(() => {
        if (error.noteText === "") {
            setIsButtonDisable(false);
        } else {
            setIsButtonDisable(true);
        }
    }, [error]);


    useEffect(() => {
        fetchSparePartNote();
    }, []);

    const sparePartNoteList
        = useSelector(({ SparePart }) => SparePart.sparePartNoteList?.resultObject);

    const fetchSparePartNote = (cpage = currentPage, pageSize = rowsPerPage) => {
        let payload = {
            pageNumber: cpage + 1,
            pageSize: pageSize,
            searchText: filterText
        };
        dispatch(getSparePartNoteList(payload));
    };

    useEffect(() => {
        if (sparePartNoteList) {
            setPageLoaded(true);
            setRows(sparePartNoteList?.content);
            setTotalCount(sparePartNoteList?.totalCount);
        }
    }, [sparePartNoteList]);

    const [editable, setEditable] = useState(false);
    const [editableRow, setEditableRow] = useState("");

    const updateAddHandler = (row) => {
        if (row.id !== "") {
            const data = {
                Id: row.id,
                Note: tempNote,
                PlantId: 0
            };
            setRows(prev =>
                prev.map(r => r.id === row.id ? { ...r, note: tempNote } : r)
            );

            dispatch(updateSparePartNote(data))

        } else {
            const data = {
                Id: 0,
                Note: tempNote,
                Status: 1,
                PlantId: 0
            };

            dispatch(saveSparePartNote(data))
        }

        disableEditHandler();
    };

    const disableEditHandler = () => {
        setEditable(false);
        setEditableRow(null);
        setTempNote("");
    };

    const enableEditHandler = (row) => {
        setIsButtonDisable();
        setEditable(true);
        setEditableRow(row.id);
        setTempNote(row.note);
    }

    const deleteButtonHandler = (row) => {
        setRows(prev => prev.filter(r => r.id !== row.id));
        dispatch(deleteSparePartNote(row.id));
        setTotalCount(prev => prev - 1);

        const newTotal = totalCount - 1;
        const lastPage = Math.max(0, Math.ceil(newTotal / rowsPerPage) - 1);

        if (currentPage > lastPage) {
            setCurrentPage(lastPage);
            //fetchSparePartNote(lastPage, rowsPerPage);
        } else {
            //fetchSparePartNote(currentPage, rowsPerPage);
        }
    };

    //add blank row for new note addition
    const addBlankRowHandler = () => {
        setCurrentPage(0);
        setTempNote("");
        setIsButtonDisable();
        let blankRow = [
            {
                id: "",
                note: "",
                plantCode: "",
                plantName: "",
            }
        ];
        rows = blankRow.concat(rows);
        setEditableRow(blankRow[0].id);
        setEditable(true);
        setRows(rows);
    };

    //filter table
    const [filterText, setFilterText] = useState("");

    useEffect(() => {
        setCurrentPage(0);

        let payload = {
            pageNumber: currentPage + 1,
            pageSize: rowsPerPage,
            searchText: filterText
        };

        dispatch(getSparePartNoteList(payload))

    }, [filterText]);

    const setNoteHandler = (value) => {
        setTempNote(value);
    };

    return (
        <div>
            <StyledTableDiv>
                <h1>Spare Part Note Definitions</h1>
                <AddButton onClick={() => addBlankRowHandler()} disabled={false} />
                {pageLoaded == true ? (
                    <React.Fragment>
                        <Grid container spacing={4} alignItems="center" justifyContent="center" sx={{ marginBottom: 4 }}>
                            <Grid item xs={12} sm={12} md={4}>
                                <SearchBar
                                    value={filterText}
                                    onChange={(newValue) => setFilterText(newValue)}
                                />
                            </Grid>
                        </Grid>
                    </React.Fragment>
                ) : null}

                {rows?.length > 0 ? (
                    <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                        <TableContainer id="spNote_TableContainer">
                            <Table id="spNoteTable" aria-label="customized table">
                                <TableHead id="spHistory_TableHead">
                                    <TableRow id="spHistory_TableRow">
                                        <TableCell align="center">{t("ID")}</TableCell>
                                        <TableCell align="center">{t("Note")}</TableCell>
                                        <TableCell align="center">{t("PlantCode")}</TableCell>
                                        <TableCell align="center">{t("PlantName")}</TableCell>
                                        <TableCell align="center">{t("Actions")}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody id="spNote_TableBody">
                                    {rows.map((row, index) => (
                                        <TableRow id={`spNote_TableRow_${index}`} key={row.id}>
                                            <TableCell
                                                id={`spNote_TableCell_Id`}
                                                align="center"
                                                style={{ verticalAlign: "top" }}
                                            >
                                                {row.id}

                                            </TableCell>
                                            <TableCell id={`gt_TableCell_Note_${index}`} align="center">
                                                {editable && editableRow === row.id ? (
                                                    <TextField
                                                        id={`gt_TableCell_Note_TextField_${index}`}
                                                        onChange={(e) => setNoteHandler(e.target.value)}
                                                        value={tempNote}
                                                        variant="outlined"
                                                        inputProps={{ maxLength: "50" }}
                                                        error={error.noteText.length > 0}
                                                        helperText={error.noteText}
                                                    />
                                                ) : (
                                                    row.note
                                                )}
                                            </TableCell>
                                            <TableCell
                                                id={`spNote_TableCell_PlantCode`}
                                                align="center"
                                                style={{ verticalAlign: "top" }}
                                            >
                                                {row.plantCode}

                                            </TableCell>
                                            <TableCell
                                                id={`spNote_TableCell_PlantName`}
                                                align="center"
                                                style={{ verticalAlign: "top" }}
                                            >
                                                {row.plantName}

                                            </TableCell>
                                            <SparePartNoteActionButtons
                                                editable={editable}
                                                editableRow={editableRow}
                                                row={row}
                                                addDisabled={isButtonDisable}
                                                updateAddHandler={() => updateAddHandler(row)}
                                                disableEditHandler={() => disableEditHandler()}
                                                enableEditHandler={() => enableEditHandler(row)}
                                                deleteButtonHandler={() => deleteButtonHandler(row)}
                                            />
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                id="sp_TablePagination"
                                component="div"
                                count={totalCount}
                                rowsPerPage={rowsPerPage}
                                page={currentPage}
                                onPageChange={HandleChangePage}
                                onRowsPerPageChange={HandleChangeRowsPerPage}
                            />
                        </TableContainer>
                    </Grow>
                ) : null}
            </StyledTableDiv>
        </div>
    )
}